<div class="alert alert-warning" role="alert" *ngIf="isCompanyStillPending">
    Stiamo verificando i dati della società, attendi una nostra conferma.
</div>
<div class="alert alert-primary" role="alert" *ngIf="showSeasonMessage && !checkActiveShop()">
    Per iniziare, ti suggeriamo di aggiungere delle stagioni e delle categorie tramite la <a
        [routerLink]="['/companies/categories']">seguente pagina</a>
</div>

<div class="alert alert-danger d-flex justify-content-between align-items-center gap-3" role="alert"
     *ngIf="failedInstallmentPayments > 0">
    <span>
        <b>{{ failedInstallmentPayments === 1 ? '1 pagamento a rate' : failedInstallmentPayments + ' pagamenti a rate' }}</b>
        {{ failedInstallmentPayments === 1 ? 'ha' : 'hanno' }} una rata non riuscita.
        Controlla il motivo e contatta l'atleta se il problema riguarda la carta.
    </span>
    <button type="button" class="btn btn-sm btn-outline-danger text-nowrap" (click)="showPartialPayments()">
        Vedi pagamenti
    </button>
</div>

<app-recap></app-recap>

<!-- Selettore vista -->
<div class="mb-4 flex items-center justify-end">
    <div class="inline-flex gap-1 rounded-xl border border-solid border-slate-100 bg-white p-1 shadow-sm" role="group" aria-label="Vista della dashboard">
        <button type="button"
                class="inline-flex min-h-[34px] items-center gap-1.5 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="viewMode === 'list' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-50 hover:text-strong'"
                [attr.aria-pressed]="viewMode === 'list'" (click)="setViewMode('list')">
            <i class="bi bi-list-ul" aria-hidden="true"></i> Elenco
        </button>
        <button type="button"
                class="inline-flex min-h-[34px] items-center gap-1.5 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="viewMode === 'cards' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-50 hover:text-strong'"
                [attr.aria-pressed]="viewMode === 'cards'" (click)="setViewMode('cards')">
            <i class="bi bi-grid-1x2" aria-hidden="true"></i> Schede
            <span *ngIf="viewMode !== 'cards'" class="rounded-full px-1.5 py-px text-[10px] font-bold uppercase leading-tight"
                  style="background-color: rgba(var(--tertiary-rgb), 0.15); color: var(--tertiary-color);">Nuova</span>
        </button>
    </div>
</div>

<!-- ===================== Vista a schede ===================== -->
<div *ngIf="viewMode === 'cards'" class="relative mb-8 flex flex-col gap-6 text-strong">

    <!-- Da fare -->
    <section aria-labelledby="todo-title">
        <div class="mb-3 flex items-baseline justify-between gap-3">
            <h2 id="todo-title" class="m-0 text-xl font-semibold text-gray-900">Da fare</h2>
            <span class="text-sm text-slate-500" *ngIf="!countOf(lastPendingPaymentRegistration) && !countOf(AthleteTable) && !failedInstallmentPayments && !countOf(staffTable)">
                Nessuna attività in sospeso
            </span>
        </div>
        <div class="grid grid-cols-2 gap-4 xl:grid-cols-4">
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-payments', tone: 'tone-amber', icon: 'bi-cash-coin', label: 'Pagamenti da verificare', value: countOf(lastPendingPaymentRegistration)}"></ng-container>
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-athletes', tone: 'tone-primary', icon: 'bi-person-check', label: 'Atleti da approvare', value: countOf(AthleteTable)}"></ng-container>
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-partial-payments', tone: failedInstallmentPayments ? 'tone-red' : 'tone-tertiary', icon: failedInstallmentPayments ? 'bi-exclamation-octagon' : 'bi-calendar2-week', label: failedInstallmentPayments ? 'Rate non riuscite' : 'Pagamenti a rate', value: failedInstallmentPayments || countOf(partialPaymentsList)}"></ng-container>
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-staff', tone: 'tone-sky', icon: 'bi-person-badge', label: 'Personale da approvare', value: countOf(staffTable)}"></ng-container>
        </div>
    </section>

    <div class="grid gap-6 lg:grid-cols-2">
        <!-- Pagamenti da verificare -->
        <section id="card-pending-payments" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Pagamenti da verificare', subtitle: 'Bonifici e pagamenti in segreteria da confermare', count: countOf(lastPendingPaymentRegistration), icon: 'bi-cash-coin'}"></ng-container>
            <ul *ngIf="pendingPaymentRows.length; else emptyPendingPayments" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingPayments', pendingPaymentRows)" class="flex flex-col gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <div class="flex items-center gap-3">
                        <ng-container *ngTemplateOutlet="avatar; context: {image: row.athlete?.image, first: row.athlete?.firstName, last: row.athlete?.lastName}"></ng-container>
                        <div class="min-w-0 flex-1">
                            <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athlete?.firstName }} {{ row.athlete?.lastName }}</p>
                            <p class="m-0 truncate text-xs text-slate-500">
                                {{ row.category?.name }} · {{ getPaymentMethodLabel(row.athletePaymentRequest?.paymentMethod) }} · {{ row.athletePaymentRequest?.createdAt | date:'dd/MM/yyyy' }}
                            </p>
                        </div>
                        <strong class="shrink-0 text-sm font-semibold tabular-nums text-strong">{{ row.athletePaymentRequest?.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                    </div>
                    <div class="flex flex-wrap items-center justify-end gap-2">
                        <button type="button" class="dash-btn-ghost !text-red-600 hover:!bg-red-50 hover:!text-red-700" (click)="rejectAthletePayment(row.athletePaymentRequest.id)">
                            Rifiuta
                        </button>
                        <button *ngIf="company.posNexiEnabled" type="button" class="dash-btn-secondary"
                                (click)="startPaymentPos(row.athletePaymentRequest.id, row.athletePaymentRequest.intentPaymentStatus)">
                            <span *ngIf="isPosInProgress(row.athletePaymentRequest.intentPaymentStatus)" class="spinner-border spinner-border-sm" style="width: 12px; height: 12px;" aria-hidden="true"></span>
                            <i *ngIf="!isPosInProgress(row.athletePaymentRequest.intentPaymentStatus)" class="bi bi-credit-card-2-front" aria-hidden="true"></i>
                            POS{{ isPosInProgress(row.athletePaymentRequest.intentPaymentStatus) ? ' in corso' : '' }}
                        </button>
                        <button type="button" class="dash-btn-primary" (click)="approveAthletePayment(row.athletePaymentRequest.id)">
                            <i class="bi bi-check-lg" aria-hidden="true"></i> Incassato
                        </button>
                    </div>
                </li>
            </ul>
            <ng-template #emptyPendingPayments>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: lastPendingPaymentRegistration?.loading, text: 'Nessun pagamento da verificare.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingPayments', rows: pendingPaymentRows, table: lastPendingPaymentRegistration}"></ng-container>
        </section>

        <!-- Atleti da approvare -->
        <section id="card-pending-athletes" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Atleti da approvare', subtitle: 'Nuovi atleti in attesa di attivazione', count: countOf(AthleteTable), icon: 'bi-person-check'}"></ng-container>
            <ul *ngIf="pendingAthleteRows.length; else emptyPendingAthletes" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingAthletes', pendingAthleteRows)" class="flex items-center gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <ng-container *ngTemplateOutlet="avatar; context: {image: row.image, first: row.firstName, last: row.lastName}"></ng-container>
                    <div class="min-w-0 flex-1">
                        <p class="m-0 flex min-w-0 items-center gap-2 text-sm font-semibold text-strong">
                            <span class="truncate">{{ row.firstName }} {{ row.lastName }}</span>
                            <span *ngIf="row.alreadyPlayedInCompany === 1" class="shrink-0 rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold text-slate-600">Già tesserato</span>
                        </p>
                        <p class="m-0 truncate text-xs text-slate-500">
                            <ng-container *ngIf="bornDateLabel(row.bornDate) as born">Nato il {{ born }} · </ng-container>richiesta del {{ row.createdAt | date:'dd/MM/yyyy' }}
                        </p>
                    </div>
                    <button type="button" class="dash-btn-icon hover:!bg-red-50 hover:!text-red-600"
                            [attr.aria-label]="'Elimina ' + row.firstName + ' ' + row.lastName" title="Elimina atleta"
                            (click)="deleteAthlete(row.id)">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                    </button>
                    <a [routerLink]="['/users/profile', row.id]" class="dash-btn-primary shrink-0">Rivedi</a>
                </li>
            </ul>
            <ng-template #emptyPendingAthletes>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: AthleteTable?.loading, text: 'Nessun atleta in attesa di approvazione.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingAthletes', rows: pendingAthleteRows, table: AthleteTable}"></ng-container>
        </section>

        <!-- Pagamenti a rate -->
        <section id="card-partial-payments" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Pagamenti a rate in corso', subtitle: 'Piani POS a rate non ancora completati', count: countOf(partialPaymentsList), icon: 'bi-calendar2-week'}"></ng-container>
            <ul *ngIf="partialPaymentRows.length; else emptyPartialPayments" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('partialPayments', partialPaymentRows)" class="px-5 py-4 transition hover:bg-slate-50/60">
                    <div class="flex items-center gap-3">
                        <ng-container *ngTemplateOutlet="avatar; context: {image: row.athleteImage, first: row.athleteFirstName, last: row.athleteLastName}"></ng-container>
                        <div class="min-w-0 flex-1">
                            <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athleteFirstName }} {{ row.athleteLastName }}</p>
                            <p class="m-0 truncate text-xs text-slate-500">{{ row.categoryName }} · {{ getPaymentMethodLabel(row.paymentMethod) }}</p>
                        </div>
                        <a class="dash-btn-secondary shrink-0"
                           [routerLink]="[isSuperAdmin() ? '/admins/payment-installments' : '/companies/payment-installments', row.id]"
                           [attr.aria-label]="'Apri il dettaglio delle rate di ' + row.athleteFirstName + ' ' + row.athleteLastName">
                            Vedi rate
                        </a>
                    </div>
                    <div class="mt-3 flex items-center gap-3 pl-[3.25rem]">
                        <div class="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-100" aria-hidden="true">
                            <div class="h-full rounded-full" [ngClass]="row.paymentIssue ? 'bg-red-500' : 'bg-primary'" [style.width.%]="installmentProgress(row)"></div>
                        </div>
                        <span class="shrink-0 text-xs tabular-nums text-slate-600">
                            {{ row.completedInstallments }}/{{ row.totalInstallments }} rate · {{ (row.paidAmount || 0) | currency:'EUR':'symbol':'1.2-2':'it' }} di {{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}
                        </span>
                    </div>
                    <p *ngIf="row.paymentIssue" class="mb-0 ml-[3.25rem] mt-2 rounded-lg border border-solid border-red-100 bg-red-50 px-3 py-2 text-xs leading-5 text-red-800">
                        <b>Rata {{ row.paymentIssue.installmentNumber }} {{ row.paymentIssue.status === 'unknown' ? 'da verificare' : 'non riuscita' }}</b>
                        <span *ngIf="row.paymentIssue.errorMessage"> · {{ row.paymentIssue.errorMessage }}</span>
                        <span *ngIf="row.paymentIssue.nextRetryAt" class="block text-red-700/80">Nuovo tentativo il {{ row.paymentIssue.nextRetryAt | date:'dd/MM/yyyy HH:mm' }}</span>
                        <span *ngIf="row.paymentIssue.status === 'unknown'" class="block text-red-700/80">Nessun nuovo addebito finché l'esito non viene verificato su Nexi</span>
                    </p>
                </li>
            </ul>
            <ng-template #emptyPartialPayments>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: partialPaymentsList?.loading, text: 'Nessun pagamento a rate in corso.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'partialPayments', rows: partialPaymentRows, table: partialPaymentsList}"></ng-container>
        </section>

        <!-- Personale da approvare -->
        <section id="card-pending-staff" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Personale da approvare', subtitle: 'Allenatori e staff in attesa di attivazione', count: countOf(staffTable), icon: 'bi-person-badge'}"></ng-container>
            <ul *ngIf="pendingStaffRows.length; else emptyPendingStaff" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingStaff', pendingStaffRows)" class="flex items-center gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <ng-container *ngTemplateOutlet="avatar; context: {image: row.image, first: row.firstName, last: row.lastName}"></ng-container>
                    <div class="min-w-0 flex-1">
                        <p class="m-0 truncate text-sm font-semibold text-strong">
                            {{ row.firstName }} {{ row.lastName }}
                            <span *ngIf="row.subtype" class="font-normal text-slate-500">· {{ row.subtype }}</span>
                        </p>
                        <p class="m-0 truncate text-xs text-slate-500">{{ row.email }}<span *ngIf="row.phone"> · {{ row.phone }}</span></p>
                    </div>
                    <button type="button" class="dash-btn-ghost !text-red-600 hover:!bg-red-50 hover:!text-red-700" (click)="rejectStaff(row.id)">Rifiuta</button>
                    <button type="button" class="dash-btn-primary" (click)="approveStaff(row.id)">Approva</button>
                </li>
            </ul>
            <ng-template #emptyPendingStaff>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: staffTable?.loading, text: 'Nessun membro dello staff in attesa.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingStaff', rows: pendingStaffRows, table: staffTable}"></ng-container>
        </section>
    </div>

    <!-- Pagamenti ricevuti -->
    <section class="dash-section">
        <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Pagamenti ricevuti', subtitle: 'Tutti i pagamenti completati dagli atleti', count: countOf(paymentsList), icon: 'bi-wallet2'}"></ng-container>
        <form class="flex flex-col gap-2 border-0 border-b border-solid border-slate-100 px-5 py-3 sm:flex-row sm:items-center" (ngSubmit)="filterSearch()">
            <label for="cards-athlete-filter" class="sr-only">Cerca atleta</label>
            <div class="relative min-w-0 flex-1">
                <i class="bi bi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" aria-hidden="true"></i>
                <input id="cards-athlete-filter" type="search" name="cardsAthleteFilter" placeholder="Cerca per nome o cognome"
                       class="!m-0 !box-border !h-9 !w-full !rounded-lg !border !border-solid !border-slate-200 !bg-white !py-0 !pl-9 !pr-3 !text-sm !text-slate-800 !shadow-none focus:!border-primary focus:!outline-none"
                       [(ngModel)]="athleteTextFilter">
            </div>
            <label for="cards-method-filter" class="sr-only">Metodo di pagamento</label>
            <select id="cards-method-filter" name="cardsMethodFilter"
                    class="!m-0 !h-9 !rounded-lg !border !border-solid !border-slate-200 !bg-white !py-0 !pl-3 !text-sm !text-slate-800 sm:!w-52"
                    [(ngModel)]="selectedPaymentMethod" (ngModelChange)="filterSearch()">
                <option value="">Tutti i metodi</option>
                <option *ngFor="let method of paymentMethods" [ngValue]="method">{{ getPaymentMethodLabel(method) }}</option>
            </select>
            <div class="flex gap-2">
                <button type="submit" class="dash-btn-secondary !h-9 flex-1 justify-center sm:flex-none">Cerca</button>
                <button *ngIf="athleteTextFilter || selectedPaymentMethod" type="button" class="dash-btn-ghost !h-9" (click)="resetFilters()">Azzera</button>
            </div>
        </form>
        <ul *ngIf="paymentRows.length; else emptyPayments" class="m-0 list-none divide-y divide-slate-100 p-0">
            <li *ngFor="let row of visibleRows('payments', paymentRows)" class="flex items-center gap-3 px-5 py-3 transition hover:bg-slate-50/60">
                <ng-container *ngTemplateOutlet="avatar; context: {image: row.athleteImage, first: row.athleteFirstName, last: row.athleteLastName}"></ng-container>
                <div class="min-w-0 flex-1">
                    <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athleteFirstName }} {{ row.athleteLastName }}</p>
                    <p class="m-0 truncate text-xs text-slate-500">{{ row.categoryName }} · {{ getPaymentMethodLabel(row.paymentMethod) }} · {{ row.createdAt }}</p>
                </div>
                <strong class="shrink-0 text-sm font-semibold tabular-nums text-strong">{{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                <div class="flex w-[76px] shrink-0 items-center justify-end gap-1">
                    <a *ngIf="row.totalInstallments" class="dash-btn-icon"
                       [routerLink]="[isSuperAdmin() ? '/admins/payment-installments' : '/companies/payment-installments', row.id]"
                       title="Vedi rate" [attr.aria-label]="'Apri il dettaglio delle rate di ' + row.athleteFirstName + ' ' + row.athleteLastName">
                        <i class="bi bi-list-ul" aria-hidden="true"></i>
                    </a>
                    <ng-container *ngIf="!row.totalInstallments && (row.paymentMethod === 'transfer' || row.paymentMethod === 'localPayment')">
                        <button type="button" class="dash-btn-icon" title="Modifica importo" aria-label="Modifica importo" (click)="openEditModal(row)">
                            <i class="bi bi-pencil" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="dash-btn-icon hover:!bg-red-50 hover:!text-red-600" title="Elimina pagamento" aria-label="Elimina pagamento" (click)="deletePayment(row.id)">
                            <i class="bi bi-trash" aria-hidden="true"></i>
                        </button>
                    </ng-container>
                </div>
            </li>
        </ul>
        <ng-template #emptyPayments>
            <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: paymentsList?.loading, text: 'Nessun pagamento trovato.'}"></ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'payments', rows: paymentRows, table: paymentsList}"></ng-container>
    </section>

    <!-- Ultime iscrizioni -->
    <section class="dash-section">
        <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Ultime iscrizioni', subtitle: 'Le richieste di iscrizione più recenti', count: null, icon: 'bi-clock-history'}"></ng-container>
        <ul *ngIf="recentRegistrationRows.length; else emptyRecent" class="m-0 list-none divide-y divide-slate-100 p-0">
            <li *ngFor="let row of visibleRows('recent', recentRegistrationRows)" class="flex items-center gap-3 px-5 py-3 transition hover:bg-slate-50/60">
                <ng-container *ngTemplateOutlet="avatar; context: {image: row.athlete?.image, first: row.athlete?.firstName, last: row.athlete?.lastName}"></ng-container>
                <div class="min-w-0 flex-1">
                    <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athlete?.firstName }} {{ row.athlete?.lastName }}</p>
                    <p class="m-0 truncate text-xs text-slate-500">{{ row.category?.name }} · {{ paymentTypes(row.athletePaymentRequest?.paymentMethod) }} · {{ row.athletePaymentRequest?.createdAt | date:'dd/MM/yyyy' }}</p>
                </div>
                <span class="hidden shrink-0 text-sm font-semibold tabular-nums text-strong sm:inline">{{ row.athletePaymentRequest?.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</span>
                <span class="shrink-0 rounded-md px-2 py-0.5 text-xs font-semibold" [ngClass]="requestStatus(row.athletePaymentRequest?.status).classes">
                    {{ requestStatus(row.athletePaymentRequest?.status).label }}
                </span>
            </li>
        </ul>
        <ng-template #emptyRecent>
            <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: lastRegistration?.loading, text: 'Nessuna iscrizione recente.'}"></ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'recent', rows: recentRegistrationRows, table: lastRegistration}"></ng-container>
    </section>
</div>

<ng-template #todoTile let-target="target" let-tone="tone" let-icon="icon" let-label="label" let-value="value">
    <button type="button" (click)="scrollToCard(target)"
            class="dash-tile group flex min-w-0 cursor-pointer items-center gap-4 p-4 text-left sm:p-5" [ngClass]="tone">
        <span class="dash-icon grid h-12 w-12 shrink-0 place-items-center text-2xl sm:h-14 sm:w-14">
            <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
        </span>
        <span class="min-w-0">
            <span class="dash-label mb-1 block text-[11px] font-bold uppercase leading-tight tracking-wide">{{ label }}</span>
            <span class="dash-value block text-[1.6rem] font-extrabold leading-tight">{{ value }}</span>
        </span>
    </button>
</ng-template>

<!-- Foto profilo con iniziali come fallback -->
<ng-template #avatar let-image="image" let-first="first" let-last="last">
    <img *ngIf="image; else avatarInitials" [src]="image" alt=""
         class="h-10 w-10 shrink-0 rounded-full border border-solid border-slate-200 object-cover"/>
    <ng-template #avatarInitials>
        <span class="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600">{{ initials(first, last) }}</span>
    </ng-template>
</ng-template>

<ng-template #cardHeader let-title="title" let-subtitle="subtitle" let-count="count" let-icon="icon">
    <header class="flex items-center gap-3 border-0 border-b border-solid border-slate-100 px-5 py-4">
        <span class="grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-solid border-slate-200 text-base text-slate-500">
            <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
        </span>
        <div class="min-w-0 flex-1">
            <h3 class="m-0 flex items-center gap-2 text-[15px] font-semibold text-gray-900">
                {{ title }}
                <span *ngIf="count" class="rounded-md bg-slate-100 px-1.5 py-0.5 text-xs font-semibold leading-none text-slate-600">{{ count }}</span>
            </h3>
            <p class="m-0 truncate text-xs text-slate-500">{{ subtitle }}</p>
        </div>
    </header>
</ng-template>

<ng-template #cardEmpty let-loading="loading" let-text="text">
    <div *ngIf="loading" class="flex animate-pulse flex-col gap-2 p-5" role="status" aria-label="Caricamento">
        <div class="h-10 rounded-lg bg-slate-100"></div>
        <div class="h-10 rounded-lg bg-slate-100"></div>
    </div>
    <p *ngIf="!loading" class="m-0 flex flex-1 items-center justify-center px-5 py-6 text-center text-sm text-slate-500">{{ text }}</p>
</ng-template>

<ng-template #cardFooter let-section="section" let-rows="rows" let-table="table">
    <footer *ngIf="rows.length > cardPreviewSize || (table && table.pagesCount > 1 && expandedCardSections.has(section))"
            class="mt-auto flex items-center justify-between gap-3 border-0 border-t border-solid border-slate-100 px-5 py-2">
        <button *ngIf="rows.length > cardPreviewSize" type="button" class="dash-btn-ghost" (click)="toggleCardSection(section)">
            {{ expandedCardSections.has(section) ? 'Mostra meno' : 'Mostra tutti (' + (table?.totalCount || rows.length) + ')' }}
            <i class="bi" [ngClass]="expandedCardSections.has(section) ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
        </button>
        <div *ngIf="table && table.pagesCount > 1 && expandedCardSections.has(section)" class="ml-auto flex items-center gap-1 text-xs text-slate-500">
            <button type="button" class="dash-btn-icon" [disabled]="table.currentPage === 0 || table.loading" (click)="table.previousPagePagination()" aria-label="Pagina precedente">
                <i class="bi bi-chevron-left" aria-hidden="true"></i>
            </button>
            <span class="tabular-nums">{{ table.currentPage + 1 }} / {{ table.pagesCount }}</span>
            <button type="button" class="dash-btn-icon" [disabled]="table.currentPage >= table.pagesCount - 1 || table.loading" (click)="table.nextPagePagination()" aria-label="Pagina successiva">
                <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
        </div>
    </footer>
</ng-template>

<div class="modal fade show" tabindex="-1" *ngIf="selectedPayment" style="display:block; background: rgba(0,0,0,0.5);">

    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Dettaglio Pagamento</h5>
                <button type="button" class="btn-close" (click)="closeEditModal()">
                </button>
            </div>

            <div class="modal-body">

                <div class="mb-3">
                    <label class="form-label">
                        <b>Atleta</b>:
                        {{ selectedPayment?.athleteFirstName }}
                        {{ selectedPayment?.athleteLastName }}
                    </label>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        <b>Metodo di pagamento</b>:
                        {{ getPaymentMethodLabel(selectedPayment?.paymentMethod) }}
                    </label>
                </div>

                <div class="mb-3 d-flex align-items-center gap-2">
                    <label class="form-label mb-0"><b>Importo</b>:</label>
                    <input type="number" class="form-control w-auto" [(ngModel)]="editAmount" min="0">
                </div>

            </div>

            <div class="modal-footer">
                <button class="btn btn-secondary" (click)="closeEditModal()">
                    Annulla
                </button>

                <button class="btn btn-primary" (click)="confirmEdit()">
                    Salva
                </button>
            </div>

        </div>
    </div>
</div>



<!-- ===================== Vista elenco (classica) ===================== -->
<!-- Le tabelle restano montate anche nella vista a schede: caricano i dati usati da entrambe. -->
<div [hidden]="viewMode !== 'list'">
<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapseAthletesTable = !collapseAthletesTable">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Atleti in attesa di approvazione</span>
            <span class="table-desc-custom mt-1">In questa lista ci sono tutti gli atleti che devono essere accettati dalla società</span>
        </div>
        <i class="bi" [ngClass]="collapseAthletesTable ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseAthletesTable">
        <ui-table #AthletesTable class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Cognome e Nome</th>
                    <th>Data di nascita</th>
                    <th>Già tesserato qui?</th>
                    <th>Data richiesta</th>
                    <th scope="col" class="d-flex justify-content-end pe-5"> Azioni</th>
                </tr>
            </ng-template>

            <ng-template #customRow let-row="row">
                <tr>
                    <td>
                        {{ row.firstName }} {{ row.lastName }}
                    </td>
                    <td>
                        {{ formatDateForTable(row.bornDate) }}
                    </td>
                    <td>
                        {{ row.alreadyPlayedInCompany === 1 ? 'Sì' : 'No' }}
                    </td>
                    <td>
                        {{ row.createdAt | date:'dd-MM-yyyy' }}
                    </td>
                    <td>
                        <div class="d-flex justify-content-end">
                            <a class="btn btn-light me-2" [routerLink]="['/users/profile', row.id]"
                               [queryParams]="{'approvingAthlete': 1}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-pencil"
                                     viewBox="0 0 16 16">
                                    <path
                                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                </svg>
                            </a>
                            <button class="btn btn-light " (click)="deleteAthlete(row.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-trash"
                                     viewBox="0 0 16 16">
                                    <path
                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                    <path
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                </svg>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapseRegistrationConfirmation = !collapseRegistrationConfirmation">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Utenti in attesa di confermare l'iscrizione</span>
            <span class="table-desc-custom mt-1">Utenti che devono ancora confermare la propria iscrizione.</span>
        </div>
        <i class="bi"
           [ngClass]="collapseRegistrationConfirmation ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseRegistrationConfirmation">
        <ui-table #pendingRegistrationConfirmation class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Utente</th>
                    <th>Email</th>
                    <th>Telefono</th>
                    <th>Data di creazione</th>
                    <th>Azioni</th>
                </tr>
            </ng-template>
            <ng-template #customRow let-row="row">
                <tr>
                    <td>{{ row?.firstName }} {{ row?.lastName }}</td>
                    <td>{{ row?.email }}</td>
                    <td>{{ row?.phone }}</td>
                    <td>{{ formatDateForTable(row?.createdAt) }}</td>
                    <td>
                        <button class="btn btn-light " (click)="deletePendingConfirmationUser(row.id)"
                                [attr.aria-label]="'Elimina utente ' + row.firstName + ' ' + row.lastName">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-trash"
                                 viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                            </svg>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapsePendingPayments = !collapsePendingPayments">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Pagamenti da approvare</span>
            <span class="table-desc-custom mt-1">Riepilogo delle ultime iscrizioni effettuate e da confermare il pagamento.</span>
        </div>
        <i class="bi" [ngClass]="collapsePendingPayments ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapsePendingPayments">
        <ui-table #lastPendingPaymentRegistration class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Nome</th>
                    <th>Categoria</th>
                    <th>Importo</th>
                    <th>Metodo di pagamento</th>
                    <th>Stato del pagamento</th>
                    <th>Data del pagamento</th>
                    <th>Approva / Rifiuta Pagamento</th>
                </tr>
            </ng-template>

            <ng-template #customRow let-row="row">
                <tr>
                    <td>
                        {{ row.athlete.firstName }} {{ row.athlete.lastName }}
                    </td>
                    <td>
                        {{ row.category.name }}
                    </td>
                    <td>
                        {{ row.athletePaymentRequest.amount | number:'':'it' }}€
                    </td>
                    <td>
                        {{
                            row.athletePaymentRequest.paymentMethod === 'localPayment' ? 'Pagamento in segreteria' :
                                (row.athletePaymentRequest.paymentMethod === 'transfer' ? 'Bonifico bancario' :
                                    row.athletePaymentRequest.paymentMethod)
                        }}
                    </td>

                    <td>
                        <span *ngIf="row.athletePaymentRequest.status === 'paid' "
                              class="badge badge-success"> Pagato </span>
                        <span *ngIf="row.athletePaymentRequest.status === 'pendingPayment'" class="badge badge-warning"> In
                    attesa del pagamento</span>
                        <span *ngIf="row.athletePaymentRequest.status === 'notPaid'" class="badge badge-error">Errore
                    pagamento</span>
                    </td>
                    <td>
                        {{ row.athletePaymentRequest.createdAt | date:'dd/MM/yyyy' }}
                    </td>
                    <td>
                        <div class="d-flex justify-content-start">
                            <ng-container *ngIf="row.athletePaymentRequest.paymentMethod === 'localPayment'">
                                <button
                                        class="btn wisper-btn-success my d-flex align-items-center gap-2"
                                        style="margin-right: 5px"
                                        (click)="approveAthletePayment(row.athletePaymentRequest.id)">
                                    <i class="bi bi-cash"></i>
                                    Contanti
                                </button>
                                <button
                                        *ngIf="company.posNexiEnabled"
                                        class="btn my d-flex align-items-center gap-2"
                                        [ngClass]="{
                    'wisper-btn-success': !(row.athletePaymentRequest.intentPaymentStatus === 'STARTED' ||
                                            row.athletePaymentRequest.intentPaymentStatus === 'SENT' ||
                                            row.athletePaymentRequest.intentPaymentStatus === 'RECEIVED'),
                    'btn-primary': row.athletePaymentRequest.intentPaymentStatus === 'STARTED' ||
                                   row.athletePaymentRequest.intentPaymentStatus === 'SENT' ||
                                   row.athletePaymentRequest.intentPaymentStatus === 'RECEIVED'}"
                                        style="margin-right: 5px"
                                        (click)="startPaymentPos(row.athletePaymentRequest.id,row.athletePaymentRequest.intentPaymentStatus )">
                                    <div
                                            *ngIf="row.athletePaymentRequest.intentPaymentStatus === 'STARTED' ||
                           row.athletePaymentRequest.intentPaymentStatus === 'SENT' ||
                           row.athletePaymentRequest.intentPaymentStatus === 'RECEIVED'"
                                            class="spinner-border spinner-border-sm"
                                            role="status"
                                            style="width: 16px; height: 16px;">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>

                                    <svg
                                            *ngIf="row.athletePaymentRequest.intentPaymentStatus !== 'STARTED' &&
                           row.athletePaymentRequest.intentPaymentStatus !== 'SENT' &&
                           row.athletePaymentRequest.intentPaymentStatus !== 'RECEIVED'"
                                            fill="#fff"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                              d="M16,6 L20,6 C21.1045695,6 22,6.8954305 22,8 L22,16 C22,17.1045695 21.1045695,18 20,18 L16,18 L16,19.9411765 C16,21.0658573 15.1177541,22 14,22 L4,22 C2.88224586,22 2,21.0658573 2,19.9411765 L2,4.05882353 C2,2.93414267 2.88224586,2 4,2 L14,2 C15.1177541,2 16,2.93414267 16,4.05882353 L16,6 Z M20,11 L16,11 L16,16 L20,16 L20,11 Z M14,19.9411765 L14,4.05882353 C14,4.01396021 13.9868154,4 14,4 L4,4 C4.01318464,4 4,4 4,4.05882353 L4,19.9411765 C4,19.9860398 4.01318464,20 4,20 L14,20 C13.9868154,20 14,19.9860398 14,19.9411765 Z"/>
                                    </svg>
                                    <span>{{ getPaymentStatusLabel(row.athletePaymentRequest.intentPaymentStatus) }}</span>
                                </button>
                            </ng-container>

                            <button
                                    *ngIf="row.athletePaymentRequest.paymentMethod === 'transfer'"
                                    class="btn wisper-btn-success my d-flex align-items-center gap-2"
                                    style="margin-right: 5px"
                                    (click)="approveAthletePayment(row.athletePaymentRequest.id)">

                                <i class="bi bi-check-lg"></i>
                                Approva
                            </button>


                            <button
                                    *ngIf="row.athletePaymentRequest.paymentMethod === 'localPayment' ||
                   row.athletePaymentRequest.paymentMethod === 'transfer'"
                                    class="btn wisper-btn-danger d-flex align-items-center gap-2"
                                    (click)="rejectAthletePayment(row.athletePaymentRequest.id)">

                                <i class="bi bi-x"></i>
                                Rifiuta
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>
<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapsePaymentsList = !collapsePaymentsList">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Gestione Pagamenti Atleti</span>
            <span class="table-desc-custom mt-1">Riepilogo dei pagamenti effettuati dagli atleti.</span>
        </div>
        <i class="bi" [ngClass]="collapsePaymentsList ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapsePaymentsList">
        <ui-table #paymentsList class="no-box-model">
            <ng-template #customFilter>
                <div class="row">
                    <div class="col-6">
                        <label for="athleteFilter" class="form-label">Nome / Cognome Atleta</label>
                        <input type="text" class="form-control" id="athleteFilter" [(ngModel)]="athleteTextFilter"
                               [ngModelOptions]="{ standalone: true }">
                    </div>

                    <div class="col-6">
                        <label for="paymentMethod" class="form-label">Metodo di Pagamento</label>
                        <select class="form-control form-control-solid" id="paymentMethod"
                                [(ngModel)]="selectedPaymentMethod">
                            <option value="">Tutti</option>
                            <option *ngFor="let method of paymentMethods" [ngValue]="method">
                                {{ getPaymentMethodLabel(method) }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 text-right">
                        <div style="margin-top: 10px;">
                            <button class="btn btn-default pull-right" (click)="resetFilters()">Reset</button>
                            <button class="btn btn-primary pull-right" (click)="filterSearch()">Cerca</button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #customHeader>
                <tr>
                    <th>Atleta</th>
                    <th>Metodo di Pagamento</th>
                    <th>Categoria</th>
                    <th>Importo</th>
                    <th>Data</th>
                    <th class="text-right">Azioni</th>
                </tr>
            </ng-template>
            <ng-template #customRow let-row="row">
                <tr>
                    <td>{{ row.athleteFirstName + ' ' + row.athleteLastName }}</td>
                    <td><span>{{ getPaymentMethodLabel(row.paymentMethod) }}</span></td>
                    <td><span>{{ row.categoryName }}</span></td>
                    <td>
                        <ng-container *ngIf="editingPaymentId !== row.id">
                            {{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}
                        </ng-container>
                    </td>
                    <td><span>{{ row.createdAt }}</span></td>
                    <td class="text-right">
                        <div class="d-flex justify-content-end"
                             *ngIf="row.paymentMethod === 'transfer' || row.paymentMethod === 'localPayment' || row.totalInstallments">

                            <a *ngIf="row.totalInstallments"
                               class="btn welldone-btn me-2"
                               [routerLink]="[isSuperAdmin() ? '/admins/payment-installments' : '/companies/payment-installments', row.id]"
                               title="Vedi rate"
                               [attr.aria-label]="'Apri il dettaglio delle rate di ' + row.athleteFirstName + ' ' + row.athleteLastName">
                                <i class="bi bi-list-ul"></i>
                            </a>

                            <button *ngIf="!row.totalInstallments" class="btn welldone-btn me-2"
                                    (click)="openEditModal(row)"
                                    title="Modifica importo">
                                <i class="fa fa-pencil"></i>
                            </button>

                            <button *ngIf="!row.totalInstallments" type="button"
                                    class="btn welldone-btn d-flex align-items-center justify-content-center"
                                    (click)="deletePayment(row.id)"
                                    title="Elimina pagamento">
                                <i class="fa fa-trash"></i>
                            </button>

                        </div>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>


<div id="partial-payments" class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapsePartialPayments = !collapsePartialPayments">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">
                Pagamenti parziali
                <span *ngIf="failedInstallmentPayments > 0" class="badge badge-error ms-2">
                    {{ failedInstallmentPayments }} non riusciti
                </span>
            </span>
            <span class="table-desc-custom mt-1">Riepilogo dei pagamenti POS a rate non ancora completati.</span>
        </div>
        <i class="bi"
           [ngClass]="collapsePartialPayments ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapsePartialPayments">
        <ui-table #partialPaymentsList class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Atleta</th>
                    <th>Metodo di pagamento</th>
                    <th>Categoria</th>
                    <th>Importo</th>
                    <th>Stato</th>
                    <th>Data</th>
                    <th>Dettaglio</th>
                </tr>
            </ng-template>
            <ng-template #customRow let-row="row">
                <tr>
                    <td>{{ row.athleteFirstName }} {{ row.athleteLastName }}</td>
                    <td>{{ getPaymentMethodLabel(row.paymentMethod) }}</td>
                    <td>{{ row.categoryName }}</td>
                    <td>
                        {{ (row.paidAmount || 0) | currency:'EUR':'symbol':'1.2-2':'it' }}
                        di
                        {{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}
                        pagato
                    </td>
                    <td>
                        <span *ngIf="!row.paymentIssue" class="badge badge-warning">Pagamento parziale</span>
                        <span *ngIf="row.paymentIssue?.status === 'failed'" class="badge badge-error">
                            Rata {{ row.paymentIssue.installmentNumber }} non riuscita
                        </span>
                        <span *ngIf="row.paymentIssue?.status === 'unknown'" class="badge badge-error">
                            Rata {{ row.paymentIssue.installmentNumber }} da verificare
                        </span>
                        <small class="d-block mt-1 text-muted">
                            {{ row.completedInstallments }} di {{ row.totalInstallments }} rate pagate
                        </small>
                        <small *ngIf="row.paymentIssue?.errorMessage" class="d-block text-danger">
                            Motivo: {{ row.paymentIssue.errorMessage }}
                        </small>
                        <small *ngIf="row.paymentIssue?.nextRetryAt" class="d-block text-muted">
                            Nuovo tentativo il {{ row.paymentIssue.nextRetryAt | date:'dd/MM/yyyy HH:mm' }}
                        </small>
                        <small *ngIf="row.paymentIssue?.status === 'unknown'" class="d-block text-muted">
                            Nessun nuovo addebito finché l'esito non viene verificato su Nexi
                        </small>
                    </td>
                    <td>{{ row.createdAt }}</td>
                    <td>
                        <a class="btn btn-sm welldone-btn-light"
                           [routerLink]="[isSuperAdmin() ? '/admins/payment-installments' : '/companies/payment-installments', row.id]"
                           [attr.aria-label]="'Apri il dettaglio delle rate di ' + row.athleteFirstName + ' ' + row.athleteLastName">
                            Vedi rate
                        </a>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>


<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapseLastRegistration = !collapseLastRegistration">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Ultime iscrizioni</span>
            <span class="table-desc-custom mt-1">Riepilogo delle ultime iscrizioni effettuate.</span>
        </div>
        <i class="bi" [ngClass]="collapseLastRegistration ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseLastRegistration">
        <ui-table #lastRegistration class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Nome</th>
                    <th>Categoria</th>
                    <th>Importo</th>
                    <th>Metodo di pagamento</th>
                    <th>Stato del pagamento</th>
                    <th>Data del pagamento</th>
                </tr>
            </ng-template>

            <ng-template #customRow let-row="row">
                <tr>
                    <td>
                        {{ row.athlete.firstName }} {{ row.athlete.lastName }}
                    </td>
                    <td>
                        {{ row.category.name }}
                    </td>
                    <td>
                        {{ row.athletePaymentRequest.amount | number:'':'it' }}€
                    </td>
                    <td>
                        {{ paymentTypes(row.athletePaymentRequest.paymentMethod) }}
                    </td>

                    <td>
                        <span *ngIf="row.athletePaymentRequest.status === 'paid' "
                              class="badge badge-success"> Pagato </span>
                        <span *ngIf="row.athletePaymentRequest.status === 'partialPayment'" class="badge badge-warning">
                    Pagamento parziale
                </span>
                        <span *ngIf="row.athletePaymentRequest.status === 'pendingPayment'" class="badge badge-warning"> In
                    attesa del pagamento</span>
                        <span *ngIf="row.athletePaymentRequest.status === 'notPaid'" class="badge badge-error">Errore
                    pagamento</span>
                    </td>
                    <td>
                        {{ row.athletePaymentRequest.createdAt | date:'dd/MM/yyyy' }}
                    </td>

                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom"
         (click)="collapseStaffTable = !collapseStaffTable">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Personale in attesa di approvazione</span>
            <span class="table-desc-custom mt-1">In questa lista ci sono tutto il personale in attesa di essere 'Attivato'.</span>
        </div>
        <i class="bi" [ngClass]="collapseStaffTable ? 'bi-chevron-down' : 'bi-chevron-up'"
           style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseStaffTable">
        <ui-table #staffsTable class="no-box-model">
            <ng-template #customHeader>
                <tr>
                    <th>Nome</th>
                    <th>Cognome</th>
                    <th>Data richiesta</th>
                    <th>Recapiti</th>
                    <th>Ruolo</th>
                    <th scope="col" class="d-flex justify-content-end pe-5"> Azioni</th>
                </tr>
            </ng-template>

            <ng-template #customRow let-row="row">
                <tr>
                    <td> {{ row.firstName }}</td>
                    <td>{{ row.lastName }}</td>
                    <td> {{ formatDateForTable(row.createdAt) }}</td>
                    <td>
                        <div class="mb-2">{{ row.email }}</div>
                        <div>{{ row.phone }}</div>
                    </td>
                    <td> {{ row.subtype }}</td>
                    <td>
                        <div class="d-flex justify-content-end">
                            <button class="btn welldone-btn-success me-2" (click)="approveStaff(row.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                                </svg>
                            </button>
                            <button class="btn welldone-btn-danger"
                                    (click)="rejectStaff(row.id)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     class="bi bi-trash" viewBox="0 0 16 16">
                                    <path
                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                    <path
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                </svg>
                            </button>

                        </div>
                    </td>
                </tr>
            </ng-template>
        </ui-table>
    </div>
</div>

</div>

<!-- Payment Status Modal -->
<ngx-smart-modal #paymentStatusModal identifier="paymentStatusModal" [closable]="true"
                 [customClass]="'payment-status-modal'" (onClose)="onPaymentStatusModalClose()">
    <div class="payment-status-container">
        <div class="payment-status-header">
            <div class="header-text">
                <h4>Stato pagamento POS</h4>
            </div>
        </div>
        <div class="payment-status-body" [ngClass]="getStatusClass()">
            <p class="status-text">{{ paymentStatusMessage || 'Monitoraggio pagamento in corso...' }}</p>
            <div class="status-indicator"
                 *ngIf="currentPaymentStatus && currentPaymentStatus !== 'PROCESSED' && currentPaymentStatus !== 'CANCELED' && currentPaymentStatus !== 'ERROR'">
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        <div class="payment-status-footer">
            <div class="help-block" *ngIf="showHelpText">
                <p class="help-text">Hai bisogno di aiuto?</p>
                <button class="btn btn-primary help-button" (click)="retryPaymentPos()">
                    Riprova il pagamento
                </button>
                <p class="pos-connection-message">Assicurati che il tuo POS sia connesso a Internet</p>
            </div>
            <button class="btn btn-secondary" (click)="closePaymentStatusModal()"
                    *ngIf="currentPaymentStatus === 'PROCESSED' || currentPaymentStatus === 'CANCELED' || currentPaymentStatus === 'ERROR'">
                Chiudi
            </button>
        </div>
    </div>
</ngx-smart-modal>
